import { useContext, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { createUserTrace } from '../../api/Optimise';
import errorDisc from '../../assets/svg/disc/error-disc.svg';
import { ConsentContext } from '../../context/ConsentContext';
import withContentfulTag from '../../hocs/withContentfulTag';
import type { ContentfulTagProps } from '../../types/propTypes';
import { SpacerHr } from '../../ui/Styled';

const StyledH1 = styled.h1`
  margin-bottom: 25px;
`;

const StyledButton = styled(Button)`
  margin: 6px 0;
`;

const CannotConfirmContainer = ({
  contentful,
  loading,
  fetched,
}: Pick<ContentfulTagProps, 'contentful' | 'loading' | 'fetched'>) => {
  const navigate = useNavigate();
  const { consentFlow } = useContext(ConsentContext);

  useEffect(() => {
    const asyncCreateUserTrace = async () => {
      await createUserTrace('Cannot Confirm CC');
    };
    asyncCreateUserTrace().catch((e: unknown) => console.error(e));
  }, []);

  const onTryDifferentCard = () => {
    void navigate(`/smart-meter/${consentFlow}/card-details`);
  };
  const onContinue = () => {
    void navigate(`/smart-meter/${consentFlow}/meter-code`);
  };

  return (
    !loading &&
    fetched && (
      <>
        <div className="text-center mb-3">
          <img src={errorDisc} alt="Error Disc" />
        </div>
        <StyledH1>{contentful?.title}</StyledH1>
        <ReactMarkdown>{contentful?.body ?? ''}</ReactMarkdown>
        <StyledButton variant="primary" type="button" onClick={onTryDifferentCard} className="mb-3 w-100">
          {contentful?.primaryButtonText}
        </StyledButton>
        <SpacerHr label="or" />
        <StyledButton variant="outline-primary" type="button" onClick={onContinue} className="w-100">
          {contentful?.secondaryButtonText}
        </StyledButton>
      </>
    )
  );
};

export default withContentfulTag(CannotConfirmContainer, 'web_app_onboarding_cannot_confirm_page');
